var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-button exports"},[_c('button',{staticClass:"exports-button"},[_vm._v(" Exports ")]),_c('a',{staticClass:"download-link",attrs:{"href":_vm.downloadFile,"download":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }